import React, { useEffect, useState } from 'react';
import Indigo41GeorgeScreen from '../components/Indigo41GeorgeScreen';
import SpecialMessageScreen from '../components/SpecialMessageScreen';

function Indigo41George() {
  const [showAlternateScreen, setShowAlternateScreen] = useState(false);

  const rates = [
    { description: '24 h', price: '$24.00' },
    {
      description: 'Daily / Monday to Friday (6:00 am - 6:00 pm)',
      descriptionFr: 'Lundi au vendredi / 6h à 18h',
      price: '$19.95',
    },
    {
      description: 'Weekend / Saturday - Sunday',
      descriptionFr: 'Samedi et dimanche',
      price: '$19.95',
    },
    {
      description: 'Evening (6:00 pm - 6:00 am)',
      descriptionFr: 'Soirée / 18 h à 6 h',
      price: '$19.95',
    },
    {
      description: 'Lost ticket',
      descriptionFr: 'Billet perdu',
      price: '$60.00',
    },
  ];

  useEffect(() => {
    const checkDateWindow = () => {
      const now = new Date();

      // ⚠️ Tu peux ajuster les heures et les dates ici
      const start = new Date('2025-07-01T06:00:00'); //  const start = new Date('2025-07-01T06:00:00');
      const end = new Date('2025-07-02T00:00:00'); //  const end = new Date('2025-07-02T06:00:00');

      setShowAlternateScreen(now >= start && now <= end);
    };

    // Vérifie immédiatement au chargement
    checkDateWindow();

    // Rafraîchit toutes les 10 minutes (600 000 ms)
    const interval = setInterval(() => {
      checkDateWindow();
    }, 10 * 60 * 1000);

    // Nettoyage du timer au démontage du composant
    return () => clearInterval(interval);
  }, []);

  return showAlternateScreen ? (
    <SpecialMessageScreen />
  ) : (
    <Indigo41GeorgeScreen rates={rates} />
  );
}

export default Indigo41George;
